import { type UseQueryResult, useQuery } from "@tanstack/react-query";
import { getUserProviders } from "../services/providerService";
import type { ProviderListResponse } from "../types/provider";

/**
 * Phase 37 — TanStack Query hook for the patient's connected providers.
 *
 * Query key: `['user', 'providers']` — distinct from the events namespace,
 * so event-mutation predicate invalidation (`q.queryKey[0] === 'events'`)
 * does NOT refetch this list.
 * staleTime 5min so subsequent AddEventSheet opens render the dropdown instantly.
 * `enabled` lets the sheet defer the fetch until the user opens it.
 */
export function useUserProviders(opts?: {
	enabled?: boolean;
}): UseQueryResult<ProviderListResponse> {
	return useQuery<ProviderListResponse>({
		queryKey: ["user", "providers"] as const,
		queryFn: getUserProviders,
		staleTime: 5 * 60 * 1000,
		enabled: opts?.enabled ?? true,
		refetchOnWindowFocus: false,
	});
}
